import React from "react";
import "./NewsCard.css";

const NewsCard3 = () => {
  const handleSourceClick = () => {
    window.open("https://thebftonline.com/2022/06/13/gss-actuaries-to-develop-national-mortality-table/", "_blank");
  };

  return (
    <div>
    <section className="section-council">
    <div className="sectiontop-line"></div>
    <h2 className="sectiontitle">LATEST NEWS</h2>
    <div className="sectionbottom-line"></div>
    </section>
    <h2 className="newstoptitle">
    GSS, actuaries to develop National Mortality Table
    </h2>
    <div className="newscard">
    
      <img
        src="images\News\news3.jpeg" 
        alt="News"
        className="newsimage"
      />

     
      <h3 className="newstitle">
        GSS, actuaries to develop National Mortality Table
      </h3>

     
      <div className="newsmeta">
        <span className="newssource">
          Source:{" "}
          <button onClick={handleSourceClick} className="sourcelink">
            www.thebftonline.com
          </button>
        </span>
        <span className="newsdate">Mon, 13 June 2022</span>
      </div>

      
      <p className="newsdescription">
      The government statistician, Professor Samuel Kobina Anim, has indicated that the 
      Ghana Statistical Service GSS together with other stakeholders, particularly actuaries, 
      will soon begin collaboration on developing a National Mortality Table.
      <br />
      <br />
      The tool, also known as a Life Table, shows the death rate for a defined population 
      within a specific rate of time and serves as a critical guide for the development and 
      pricing of products in the life insurance and pension ecosystems.
      <br />
      <br />
      Currently, the only known mortality table in the country was developed and is 
      solely used by the Social Security and National Insurance Trust (SSNIT), 
      which experts say is limited by its scope as it focuses on formal workers covered by the 
      Scheme, as well as the age of the data.
      <br />
      <br />
      In a keynote address read on his behalf by the Head of Industrial Statistics at Service, 
      Anthony Krakah during the formal opening of the 6th African Actuarial Congress hosted by the 
      Actuarial Society of Ghana (ASG), the government statistician said the Table will serve to inform 
      data-driven decisions in the wider financial sector.
      <br />
      <br />
      “The GSS, as the producer of official statistics, continues to apply technology and 
      data to its work; and considering the activities of actuaries, we are expressing our 
      willingness to collaborate on development of the national mortality table… this is critical, 
      as for a long time the country has survived major decisions without our own mortality table, 
      and we know actuaries are the best for developing the table. We believe that working together 
      will have a groundbreaking impact on our financial sector,” he explained.
      <br />
      <br />
      Speaking on the event’s sidelines with the B&amp;FT, president of ASG Neil N.A. 
      Tagoe welcomed assurances offered by the government statistician on the subject and 
      expressed optimism that work will begin shortly &#8211; as he hinted a Memorandum of 
      Understanding toward the partnership will be formalised in the not-too-distant future.
      <br />
      <br />
      “This is a progressive gesture, as the combination of actuaries and statisticians 
      is best when undertaking quantitative endeavours. Actuaries are not only prolific 
      managers or users of data from the financial ecosystem, but also feature in streamlining 
      the collection of relevant data for different projects. This is evident as actuarial professionals 
      lead the collection of data for the construction of mortality and mobility tables around the world,” he stated.
      <br />
      <br />
      Echoing the necessity of data in policy formulation and decision-making, 
      Mr. Tagoe indicated that over the course of the next half-decade ASG will be more vocal in its 
      engagements while developing Africa-focused solutions. 
      He said, among other things, that the Society seeks to partner with the state in developing a 
      Government Actuarial Department at the Ministry of Finance to support the development of 
      valuation for government’s major social intervention programmes.
      <br />
      <br />
      Minister of Finance Ken Ofori-Atta, in a speech read on his behalf by the Head of Pension and 
      Insurance Unit of the Ministry of Finance, Benjamin Torsah-Klu, described the theme for the 
      congress &#8211; The Role of Actuaries in Risk-Based Capital Regimes and Developing Data-Driven 
      African Economies &#8211; as apt, particularly in light of the strides the state has made in its digitalisation agenda.
      <br />
      <br />
      “With increasing competition in the digital space, we would like to encourage all stakeholders 
      to be innovative in the use of data and technology,” he added.
      <br />
      <br />
      President for the International Actuary Association (IAA), Roseanne Harris, 
      commended ASG for its focus on data and education. She urged the Society to 
      further expand sensitisation on the role of actuaries to young persons.
      </p>
    </div>
    </div>
  );
};

export default NewsCard3;
